// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import type { EmployerCategory } from './types'

// Account categories, in the order they appear in the Category dropdown.
// Kept next to the EmployerCategory type these values have to stay in sync with.
export const employerCategoryOptions: { value: EmployerCategory; label: string }[] = [
  { value: 'dummy', label: 'Dummy' },
  { value: 'external', label: 'External' },
  { value: 'internal', label: 'Internal' },
  { value: 'none', label: 'None' },
]

// Employers without a category flag are treated as 'none'.
export const DEFAULT_EMPLOYER_CATEGORY: EmployerCategory = 'none'

// The API returns null for an employer with no category, so null reads as 'None'
// just like the 'none' value we send to remove a flag.
export const getEmployerCategoryLabel = (category?: EmployerCategory | null) =>
  employerCategoryOptions.find(option => option.value === category)?.label ?? 'None'
